import React from "react";

import { Grid, IconButton, Typography } from "@material-ui/core";
import PeopleRoundedIcon from "@material-ui/icons/PeopleRounded";
import { withStyles } from "@material-ui/core/styles";

import SimpleDialog from "components/SimpleDialog";
import SimpleTooltip from "components/SimpleTooltip";

import AddOwner from "./AddOwner";
import UsersTable from "./UsersTable";

import { Account, AccountStatus } from "modules/admin/accounts/accounts/accountsSlice";
import { clearUsers, getUsers, hideUsers, selectUsers, selectUsersVisibility, showUsers } from "modules/admin/accounts/users/usersSlice";
import { useAppDispatch, useAppSelector } from "store";

const StyledIconButton = withStyles(theme => ({
    root: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}))(IconButton);

interface UsersProps {
    account: Account
}

const Users: React.FC<UsersProps> = (props) => {
    const { account } = props;
    const dispatch = useAppDispatch();
    const disabled = account.status === AccountStatus.NoSubscription;
    const usersVisibility = useAppSelector(selectUsersVisibility);
    const users = useAppSelector(selectUsers);
    const show = (usersVisibility.isVisible) && (account.id === usersVisibility.accountId);

    React.useEffect(() => {
        if (show) {
            dispatch(getUsers(account.id));
        }
    }, [dispatch, show, account]);

    const handleUsersClick = () => {
        dispatch(showUsers(account.id));
    };

    const handleCancelClick = () => {
        dispatch(hideUsers());
        dispatch(clearUsers());
    };

    return (
        <>
            <SimpleTooltip title="Users">
                <span>
                    <StyledIconButton size="small" onClick={handleUsersClick} disabled={disabled}>
                        <PeopleRoundedIcon />
                    </StyledIconButton>
                </span>
            </SimpleTooltip>
            <SimpleDialog
                open={show}
                onClose={handleCancelClick}
                maxWidth="md"
                title={
                    <Typography variant="h5" component="div" gutterBottom>
                        Users
                    </Typography>
                }
                content={
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <AddOwner accountId={account.id} usersCount={users.length} />
                        </Grid>
                        <Grid item xs={12}>
                            <UsersTable />
                        </Grid>
                    </Grid>
                }
                actions={<></>}
            />
        </>
    );
};

export default Users;
